import React from 'react'

const technologies = [
  {
    name: 'Adobe Photoshop',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg',
    short: 'Ps',
  },
  {
    name: 'Figma',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg',
    short: 'F',
  },
  {
    name: 'Adobe Illustrator',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg',
    short: 'Ai',
  },
  {
    name: 'Node.js',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg',
    short: 'Node',
  },
  {
    name: 'Python',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg',
    short: 'Py',
  },
  {
    name: 'MongoDB',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg',
    short: 'MDB',
  },
  {
    name: 'React',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg',
    short: 'R',
  },
]

export function Technologies() {
  return (
    <section
      className="bg-white py-16 sm:py-20"
    >
      <style>{`
        .tech-divider {
          width: 100%;
          height: 1px;
          background: #efefef;
        }

        .tech-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          padding: 4px 12px;
          border: 1px solid #d4d4d4;
          border-radius: 999px;
          color: #666;
        }

        .tech-logo-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          padding: 24px 20px;
          border-radius: 10px;
          border: 1px solid #f0f0f0;
          transition: border-color 0.25s ease, box-shadow 0.25s ease;
          cursor: default;
          min-width: 120px;
        }

        .tech-logo-wrap:hover {
          border-color: #e0e0e0;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
        }

        .tech-logo-wrap img {
          width: 48px;
          height: 48px;
          object-fit: contain;
          filter: grayscale(1);
          opacity: 0.5;
          transition: filter 0.3s ease, opacity 0.3s ease;
        }

        .tech-fallback {
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          background: #f6f6f6;
          border: 1px solid #eee;
          font-weight: 800;
          color: #888;
          font-size: 12px;
          letter-spacing: 0.02em;
          text-transform: uppercase;
          user-select: none;
        }

        .tech-logo-wrap:hover img {
          filter: grayscale(0);
          opacity: 1;
        }

        .tech-name {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.05em;
          color: #bbb;
          text-transform: uppercase;
          transition: color 0.3s ease;
        }

        .tech-logo-wrap:hover .tech-name {
          color: #444;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">

        <div className="tech-divider mb-12" />

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12">
          <div>
            <p className="tech-tag mb-4">Stack</p>
            <h2 style={{
              fontWeight: 700,
              fontSize: "clamp(22px, 3vw, 36px)",
              lineHeight: 1.15,
              color: "#111",
            }}>
              Technologies we{" "}
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: "italic", fontWeight: 400, color: "#b91c1c" }}>work with</span>
            </h2>
          </div>
          <p style={{ fontSize: "13px", color: "#999", maxWidth: "260px", lineHeight: 1.7, textAlign: "right" }}
            className="hidden sm:block">
            We use modern, proven tools to build fast, scalable, and maintainable products.
          </p>
        </div>

        {/* Logo grid */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center" }}>
          {technologies.map((tech) => (
            <div key={tech.name} className="tech-logo-wrap">
              <img
                src={tech.logo}
                alt={tech.name}
                onError={(e) => {
                  e.currentTarget.style.display = "none"
                  const fb = e.currentTarget.nextElementSibling
                  if (fb) fb.style.display = "flex"
                }}
              />
              <span className="tech-fallback" style={{ display: "none" }}>
                {tech.short || tech.name.slice(0, 2)}
              </span>
              <span className="tech-name">{tech.name}</span>
            </div>
          ))}
        </div>

        <div className="tech-divider mt-12" />

      </div>
    </section>
  )
}